import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/self-assessment/page.tsx");
